(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["button-experience-grid"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('premium-experience-disclosure'))customElements.define('premium-experience-disclosure',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();this.addEventListener('click',e=>{const trigger=e.target.closest('.premium-experience__toggle')||(!e.target.closest('a,button')?e.target.closest('.premium-experience')?.querySelector('.premium-experience__toggle'):null);if(trigger&&this.contains(trigger))this.toggle(trigger);const close=e.target.closest('.premium-experience__close');if(close&&this.active){const current=this.active;this.close(current);current.focus({preventScroll:true});}},{signal:this.abort.signal});this.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.active){const current=this.active;this.close(current);current.focus({preventScroll:true});}},{signal:this.abort.signal});this.addEventListener('shopify:block:select',e=>{const trigger=e.target.closest('.premium-experience')?.querySelector('.premium-experience__toggle');if(trigger&&trigger!==this.active)this.toggle(trigger);},{signal:this.abort.signal});}
disconnectedCallback(){this.abort?.abort();this.querySelectorAll('.premium-experience__panel').forEach(p=>{p.getAnimations().forEach(a=>a.cancel());p.hidden=true;p.inert=true;});this.querySelectorAll('.premium-experience__toggle').forEach(b=>b.setAttribute('aria-expanded','false'));this.active=null;}
panel(trigger){return this.querySelector('#'+CSS.escape(trigger.getAttribute('aria-controls')));}
close(trigger,immediate=false){const panel=this.panel(trigger);trigger.setAttribute('aria-expanded','false');panel.inert=true;if(this.active===trigger)this.active=null;this.animate(panel,false,immediate);}
toggle(trigger){if(this.active===trigger){this.close(trigger);return;}if(this.active)this.close(this.active,true);this.active=trigger;const panel=this.panel(trigger);trigger.setAttribute('aria-expanded','true');panel.hidden=false;panel.inert=false;this.animate(panel,true);}
animate(panel,opening,immediate=false){const start=panel.hidden?0:panel.getBoundingClientRect().height;const running=panel.getAnimations().length;panel.getAnimations().forEach(a=>a.cancel());if(immediate||matchMedia('(prefers-reduced-motion: reduce)').matches){panel.hidden=!opening;return;}const end=opening?panel.scrollHeight:0;const from=opening&&!running?0:start;const animation=panel.animate([{height:from+'px',opacity:opening?0:1},{height:end+'px',opacity:opening?1:0}],{duration:300,easing:'cubic-bezier(.2,.7,.2,1)'});animation.onfinish=()=>{panel.hidden=!opening;};}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["got-premium-hero"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeroVideos(root) {
    root.querySelectorAll('.premium-hero__video').forEach((video) => {
      if (video.dataset.heroAutoplayReady) return;
      video.dataset.heroAutoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('disablepictureinpicture', '');
      video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
      video.setAttribute('tabindex', '-1');
      video.setAttribute('aria-hidden', 'true');
      video.removeAttribute('controls');
      const play = () => {
        if (!video.isConnected) return;
        if (document.hidden || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { video.pause(); return; }
        const attempt = video.play();
        if (attempt) attempt.catch(() => {});
      };
      video.addEventListener('loadedmetadata', play);
      video.addEventListener('canplay', play);
      document.addEventListener('visibilitychange', play);
      window.addEventListener('pageshow', play);
      document.addEventListener('touchend', play, { once: true, passive: true });
      window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', play);
      play();
    });
  }
  initialiseHeroVideos(document);
  document.addEventListener('shopify:section:load', (event) => initialiseHeroVideos(event.target));
  const heroCountdownTimers = new Map();

  function heroCountdownTarget(dateText, timeText) {
    const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateText.trim());
    const time = /^(\d{2}):(\d{2})$/.exec(timeText.trim());
    if (!date || !time) return NaN;
    const parts = [Number(date[1]), Number(date[2]), Number(date[3]), Number(time[1]), Number(time[2])];
    const [year, month, day, hour, minute] = parts;
    if (year < 2000 || month < 1 || month > 12 || day < 1 || day > 31 || hour > 23 || minute > 59) return NaN;
    const local = Date.UTC(year, month - 1, day, hour, minute);
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    });
    const londonParts = (timestamp) => {
      const values = {};
      formatter.formatToParts(new Date(timestamp)).forEach((part) => {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });
      return values;
    };
    let target = local;
    for (let step = 0; step < 3; step += 1) {
      const value = londonParts(target);
      const rendered = Date.UTC(value.year, value.month - 1, value.day, value.hour, value.minute, value.second);
      target += local - rendered;
    }
    const verified = londonParts(target);
    if ([verified.year, verified.month, verified.day, verified.hour, verified.minute].some((value, index) => value !== parts[index])) return NaN;
    return target;
  }

  function stopHeroCountdown(countdown) {
    if (!heroCountdownTimers.has(countdown)) return;
    window.clearInterval(heroCountdownTimers.get(countdown));
    heroCountdownTimers.delete(countdown);
  }

  function initialiseHeroCountdowns(root) {
    root.querySelectorAll('[data-hero-countdown]').forEach((countdown) => {
      stopHeroCountdown(countdown);
      countdown.hidden = true;
      let target;
      try {
        target = heroCountdownTarget(countdown.dataset.date || '', countdown.dataset.time || '');
      } catch (error) {
        return;
      }
      if (!Number.isFinite(target)) return;
      const digits = countdown.querySelector('[data-countdown-digits]');
      const ended = countdown.querySelector('[data-countdown-ended]');
      const days = countdown.querySelector('[data-countdown-days]');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      if (!digits || !ended || !days || !hours || !minutes) return;
      const update = () => {
        if (!countdown.isConnected) {
          stopHeroCountdown(countdown);
          return false;
        }
        const remaining = target - Date.now();
        if (remaining <= 0) {
          digits.hidden = true;
          ended.hidden = countdown.dataset.expiry !== 'message' || !ended.textContent.trim();
          countdown.hidden = ended.hidden;
          stopHeroCountdown(countdown);
          return false;
        }
        const totalMinutes = Math.ceil(remaining / 60000);
        days.textContent = String(Math.floor(totalMinutes / 1440)).padStart(2, '0');
        hours.textContent = String(Math.floor((totalMinutes % 1440) / 60)).padStart(2, '0');
        minutes.textContent = String(totalMinutes % 60).padStart(2, '0');
        digits.hidden = false;
        ended.hidden = true;
        countdown.hidden = false;
        return true;
      };
      if (update()) heroCountdownTimers.set(countdown, window.setInterval(update, 1000));
    });
  }

  initialiseHeroCountdowns(document);
  document.addEventListener('shopify:section:load', (event) => initialiseHeroCountdowns(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-hero-countdown]').forEach(stopHeroCountdown);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["got-testimonial-wall"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('premium-testimonial-slider')) {
customElements.define('premium-testimonial-slider', class extends HTMLElement {
connectedCallback() {
this.track = this.querySelector('.premium-testimonials__track');
this.cards = Array.from(this.querySelectorAll('.premium-testimonial'));
this.controls = this.querySelector('.premium-testimonials__controls');
this.previous = this.querySelector('[data-previous]');
this.next = this.querySelector('[data-next]');
this.position = this.querySelector('.premium-testimonials__position');
this.abort = new AbortController();
const options = { signal: this.abort.signal };
this.previous.addEventListener('click', () => this.move(-1), options);
this.next.addEventListener('click', () => this.move(1), options);
this.track.addEventListener('scroll', () => {
clearTimeout(this.timer);
this.timer = setTimeout(() => this.update(), 100);
}, { ...options, passive: true });
this.addEventListener('shopify:block:select', event => {
const card = event.target.closest('.premium-testimonial');
if (card) this.reveal(card, 'instant');
}, options);
this.observer = new ResizeObserver(() => this.update());
this.observer.observe(this.track);
this.update();
}
disconnectedCallback() {
this.abort?.abort();
this.observer?.disconnect();
clearTimeout(this.timer);
}
metrics() {
const rtl = getComputedStyle(this.track).direction === 'rtl';
const frame = this.track.getBoundingClientRect();
const edge = rtl ? frame.right - this.track.clientLeft : frame.left + this.track.clientLeft;
const distances = this.cards.map(card => {
const rect = card.getBoundingClientRect();
return rtl ? edge - rect.right : rect.left - edge;
});
let index = 0;
distances.forEach((distance, i) => {
if (Math.abs(distance) < Math.abs(distances[index])) index = i;
});
return { rtl, distances, index };
}
reveal(card, behavior) {
const { rtl, distances } = this.metrics();
this.track.scrollBy({ left: distances[this.cards.indexOf(card)] * (rtl ? -1 : 1), behavior });
}
move(direction) {
const { index } = this.metrics();
const target = Math.max(0, Math.min(this.cards.length - 1, index + direction));
this.reveal(this.cards[target], matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
}
update() {
const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
this.controls.hidden = !overflow;
if (!this.cards.length) return;
const { distances, index } = this.metrics();
this.previous.disabled = distances[0] >= -2;
const last = this.cards.length - 1;
this.next.disabled = distances[last] + this.cards[last].getBoundingClientRect().width <= this.track.clientWidth + 2;
const visible = distances.map((distance, i) => ({ distance, i })).filter(item => item.distance >= -2 && item.distance < this.track.clientWidth - 2);
const end = visible.length ? visible[visible.length - 1].i + 1 : index + 1;
this.position.textContent = `${index + 1}–${end} / ${this.cards.length}`;
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateCompactHeaders() {
    document.querySelectorAll('[data-mobile-header-breakpoint]').forEach((wrapper) => {
      const section = wrapper.closest('.shopify-section');
      if (section) section.classList.toggle('mobile-header-scrolled', window.scrollY > 10);
    });
  }
  window.addEventListener('scroll', updateCompactHeaders, { passive: true });
  window.addEventListener('pageshow', updateCompactHeaders);
  document.addEventListener('shopify:section:load', updateCompactHeaders);
  updateCompactHeaders();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (window.matchMedia(`(max-width: ${this.dataset.mobileHeaderBreakpoint}px)`).matches) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));     
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hospitality-packages"] && !Shopify.designMode) return;
  try {
    


if(!customElements.get('hospitality-package-gallery'))customElements.define('hospitality-package-gallery',class extends HTMLElement{

connectedCallback(){this.track=this.querySelector('.hospitality-package__gallery-track');this.slides=[...this.querySelectorAll('.hospitality-package__slide')];this.dots=[...this.querySelectorAll('[data-gallery-dot]')];this.prev=this.querySelector('[data-gallery-prev]');this.next=this.querySelector('[data-gallery-next]');if(!this.track||this.slides.length<2)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.hovered=false;this.focused=false;this.stopped=false;this.interval=Math.max(3000,Number(this.dataset.interval)||5000);this.prev.addEventListener('click',()=>{this.stop();this.go(this.index()-1);},options);this.next.addEventListener('click',()=>{this.stop();this.go(this.index()+1);},options);this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.stop();this.go(i);},options));this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule();},options);this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},options);this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},options);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});},options);this.track.addEventListener('pointerdown',()=>this.stop(),options);this.track.addEventListener('wheel',()=>this.stop(),{...options,passive:true});this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stop();this.go(this.index()+(e.key==='ArrowRight'?1:-1));}},options);this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},{...options,passive:true});document.addEventListener('visibilitychange',()=>this.schedule(),options);this.reduced.addEventListener('change',()=>this.schedule(),options);this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});this.observer.observe(this);this.update();}

disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.frame);}

index(){const edge=this.track.getBoundingClientRect().left;let best=0;this.slides.forEach((slide,i)=>{if(Math.abs(slide.getBoundingClientRect().left-edge)<Math.abs(this.slides[best].getBoundingClientRect().left-edge))best=i;});return best;}

go(target){const i=Math.max(0,Math.min(target,this.slides.length-1));const distance=this.slides[i].getBoundingClientRect().left-this.track.getBoundingClientRect().left;this.track.scrollBy({left:distance,behavior:this.reduced.matches?'instant':'smooth'});}

update(){const i=this.index();this.prev.hidden=i===0;this.next.hidden=i===this.slides.length-1;this.dots.forEach((dot,n)=>{if(n===i)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});}

stop(){this.stopped=true;this.schedule();}

schedule(){clearTimeout(this.timer);if(this.dataset.autoplay!=='true'||this.reduced.matches||this.stopped||this.hovered||this.focused||!this.visible||document.hidden)return;this.timer=setTimeout(()=>{this.go((this.index()+1)%this.slides.length);this.schedule();},this.interval);}

});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');          
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              $('.loading-image').removeClass('loading-image').addClass('loaded-image');
              let sameCard = document.querySelector('.from-recommended');
              if(!sameCard) return;
              let cardHeight = parseInt(sameCard.clientHeight);
              let topValue = cardHeight / 2 + 5;
              let cardTopCSS = "calc(50% - "+topValue+'px)';
              let swiperContainer = document.querySelector('.product-recommendations .swiper');
              if(!swiperContainer) return;
              let swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');
              let swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
              swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);
              swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticket-options"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ticket-option-gallery'))customElements.define('ticket-option-gallery',class extends HTMLElement{
connectedCallback(){this.track=this.querySelector('.ticket-option__gallery-track');this.slides=[...this.querySelectorAll('.ticket-option__slide')];this.dots=[...this.querySelectorAll('[data-gallery-dot]')];this.prev=this.querySelector('[data-gallery-prev]');this.next=this.querySelector('[data-gallery-next]');if(!this.track||this.slides.length<2)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.visible=false;this.hovered=false;this.focused=false;this.stopped=false;this.interval=Math.max(3000,Number(this.dataset.interval)||5000);this.prev.addEventListener('click',()=>{this.stop();this.go(this.index()-1);},options);this.next.addEventListener('click',()=>{this.stop();this.go(this.index()+1);},options);this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.stop();this.go(i);},options));this.addEventListener('pointerenter',()=>{this.hovered=true;this.schedule();},options);this.addEventListener('pointerleave',()=>{this.hovered=false;this.schedule();},options);this.addEventListener('focusin',()=>{this.focused=true;this.schedule();},options);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.schedule();});},options);this.track.addEventListener('pointerdown',()=>this.stop(),options);this.track.addEventListener('wheel',()=>this.stop(),{...options,passive:true});this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stop();this.go(this.index()+(e.key==='ArrowRight'?1:-1));}},options);this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},{...options,passive:true});document.addEventListener('visibilitychange',()=>this.schedule(),options);this.reduced.addEventListener('change',()=>this.schedule(),options);this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();},{threshold:.15});this.observer.observe(this);this.update();}
disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.frame);}
index(){const edge=this.track.getBoundingClientRect().left;let best=0;this.slides.forEach((slide,i)=>{if(Math.abs(slide.getBoundingClientRect().left-edge)<Math.abs(this.slides[best].getBoundingClientRect().left-edge))best=i;});return best;}
go(target){const i=Math.max(0,Math.min(target,this.slides.length-1));const distance=this.slides[i].getBoundingClientRect().left-this.track.getBoundingClientRect().left;this.track.scrollBy({left:distance,behavior:this.reduced.matches?'instant':'smooth'});}
update(){const i=this.index();this.prev.hidden=i===0;this.next.hidden=i===this.slides.length-1;this.dots.forEach((dot,n)=>{if(n===i)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current');});}
stop(){this.schedule();}
schedule(){clearTimeout(this.timer);if(this.dataset.autoplay!=='true'||this.reduced.matches||this.stopped||this.hovered||this.focused||!this.visible||document.hidden)return;this.timer=setTimeout(()=>{this.go((this.index()+1)%this.slides.length);this.schedule();},this.interval);}
});

  } catch(e) { console.error(e); }
})();
})();
